import React, { createContext, useContext, useEffect } from "react"
import {
  initializeAuth,
  getValidToken,
} from "./auth"

const AuthContext = createContext({
  getToken: async () => null,
})


export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}

export function AuthProvider({ children }) {
  const username = process.env.GATSBY_CRM_USERNAME || "sbfapi"
  const password = process.env.GATSBY_CRM_PASSWORD || "SBf@123123"
  const language = process.env.GATSBY_CRM_LANGUAGE || "en"

  useEffect(() => {
    async function initialize() {
      if (typeof window === "undefined") return

      if (!username || !password) {
        return
      }

      try {
        const result = await initializeAuth(username, password, language)
        
        if (!result.success) {
          console.error("Authentication failed:", result.error)
        }
      } catch (err) {
        console.error("Authentication error:", err.message)
      }
    }

    initialize()
  }, [username, password, language])

  async function getToken() {
    if (!username || !password) return null

    try {
      const result = await getValidToken(username, password, language)
      return result.success ? result.token : null
    } catch (err) {
      return null
    }
  }

  const value = { getToken }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthContext
